import { render, staticRenderFns } from "./WhatsNewLink.vue?vue&type=template&id=62710e20&scoped=true"
import script from "./WhatsNewLink.vue?vue&type=script&lang=ts"
export * from "./WhatsNewLink.vue?vue&type=script&lang=ts"
import style0 from "./WhatsNewLink.vue?vue&type=style&index=0&id=62710e20&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62710e20",
  null
  
)

export default component.exports